import React from "react";
import withLayout from "../../../components/desktop/layout/component";
import ErrorHandler from "../../../components/shared/with-error-handler";
import EChallanMetaTags from "../../../components/shared/e-challan-meta-tags";
import EChallan from "../../../components/desktop/e-challan";
import withReducer from "../../../components/shared/with-reducer";
import injectable from "./injectable";
import PropTypes from "prop-types";

const EChallanContainer = ({ history }) => {
    return (
        <ErrorHandler>
            <EChallanMetaTags history={history} />
            <EChallan />
        </ErrorHandler>
    );
};

EChallanContainer.propTypes = {
    history: PropTypes.object
};

export default withReducer(injectable)(() => ({}), dispatch => ({dispatch}))(
    withLayout(
        EChallanContainer,
        true,
        true,
        false,
        false
    )
);
